import { NetCDFReader } from 'netcdfjs'
import type { Dimension, Variable } from '../stores/dataStore'

interface NetCDFData {
  dimensions: Dimension[]
  variables: Variable[]
  attributes: Record<string, any>
  reader: NetCDFReader
}

export const processNetCDF = (buffer: ArrayBuffer): NetCDFData => {
  const reader = new NetCDFReader(buffer)
  
  const dimensions = reader.dimensions.map(dim => ({
    name: dim.name,
    size: dim.size
  }))

  const variables = reader.variables.map(variable => ({
    name: variable.name,
    dimensions: variable.dimensions.map(String),
    attributes: variable.attributes,
    type: variable.type
  }))

  return {
    dimensions,
    variables,
    attributes: reader.globalAttributes,
    reader
  }
} 